import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { theme } from '../../../theme/theme';

import { TextSmall } from '../../../components/common/text/TextSmall';
import { Hint } from '../../../components/forms/Hint';

export function DeviceSettingsLabel(props) {
  return (
    <S.Root className={props.className}>
      <S.Header color={theme.color.text_light}>
        <S.Label name={props.name} label={props.label} title={props.label}>
          {props.label}
        </S.Label>
        {props.hint && <Hint hint={props.hint} />}
      </S.Header>
      <S.Value tabIndex={0}>{props.defaultValue}</S.Value>
    </S.Root>
  );
}

function S() {}
DeviceSettingsLabel.S = S;

S.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  hint: PropTypes.string,
  placeholder: PropTypes.string,
};

S.Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

S.Header = styled(TextSmall)`
  margin-bottom: 5px;

  /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
  & :not(:first-child) {
    margin-inline-start: 5px;
  }
`;

S.Label = styled.label`
  display: inline;
  min-width: 0;
  margin-bottom: 0;
`;

S.Value = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  min-height: 37px;
  padding: 8px;
  background: ${theme.color.mono_050};
  color: ${theme.color.text_light};
  border: 1px solid ${theme.input.border};
  border-radius: ${theme.input.border_radius};
  word-break: break-word;
`;
